import gql from 'graphql-tag';

export default gql`
  mutation UpdateFlowSettings($accountId: ID!, $update: FlowSettings_Update!) {
    updateFlowSettings(accountId: $accountId, update: $update) {
      unsubscribeLinkText
    }
  }
`;
